module.exports = __webpack_public_path__ + "static/media/transparence.297caaf0.png";